import { useState, useEffect } from 'react';

function Titles({selectedData, currentStep, model, modelTop, modelValance, modelFringe, modelTopColor, modelBottom }) {
	const [mainTitle, setMainTitle] = useState('Choose a Model');
	const [subTitle, setSubTitle] = useState("");

	useEffect(() => {
		let toleransOfIndex	= 0;
		if (!selectedData) {
			return;
		}

		if (currentStep === 1) { // 1
			setMainTitle(selectedData.groupTitle)
			setSubTitle(selectedData.name)
		}
		
		if (currentStep === 2) { // 2
			setMainTitle(selectedData.parts.top.groupTitle)
			setSubTitle(modelTop.name)
		}
		
		if(!!modelTop.valance){ toleransOfIndex+=1; };// increase if valance exist
		if (currentStep === (2 + toleransOfIndex) && !!modelTop.valance ) { // 2.1
			setMainTitle(modelTop.valance.groupTitle);
			setSubTitle(!!modelValance.name ? modelValance.name: "");
		}
		
		if(!!modelValance.fringe){ toleransOfIndex+=1; };// increase if valance exist
		if (currentStep === (2 + toleransOfIndex) && !!modelValance.fringe ) { // 2.2
			setMainTitle(modelValance.fringe.groupTitle);
			setSubTitle(!!modelFringe.name ? modelFringe.name: "");
		}

		if (currentStep === (3 + toleransOfIndex) && !!model ) { // 3;
			setMainTitle(modelTop.colors.groupTitle);
			setSubTitle(modelTopColor.name);
		}
		
		if (currentStep === (4 + toleransOfIndex) && !!modelBottom ) { // 4
			setMainTitle(selectedData.parts.main.groupTitle);
			setSubTitle(selectedData.parts.main.colors[model.activeColorIndex === undefined ? 0 : model.activeColorIndex].name);
		}
		
		if (currentStep === (5 + toleransOfIndex) && !!modelBottom ) { // 4
			setMainTitle(selectedData.parts.bottom.groupTitle);
			setSubTitle(modelBottom.name);
		}

		if (currentStep === (6 + toleransOfIndex) && !!modelBottom ) { // 4
			setMainTitle("Submit your order");
			setSubTitle("Please fill in the form below and submit your order.");
		}

	}, [currentStep, model, modelTop, modelValance, modelFringe, modelTopColor, modelBottom])

	return (
		<>
			<h5>Step {currentStep}</h5>
			<h4>{mainTitle}</h4>
			<h6>{subTitle}</h6>
		</>
	);
}

export default Titles;